import "./TimelineBarChart.scss";

import { dateToMddyy } from "../../utils/date-utils";
import { formatPercent } from "../../utils/format-utils";

interface TimelineAxisRowProps {
  id: number;
  name: string;
  promo: string;
  specialOffer: string;
  percentageDiscount: number | null;
  startDate: Date;
  endDate: Date;
}

const TimelineAxisRow: React.FC<TimelineAxisRowProps> = ({
  id,
  name,
  promo,
  specialOffer,
  percentageDiscount,
  startDate,
  endDate,
}) => {
  return (
    <div className={`yAxisTick ${id % 2 === 0 ? "backgroundGrey" : ""}`}>
      <div className="promo">
        <span>{promo}</span>
      </div>
      <div className="specialOffer">
        <span>{specialOffer}</span>
      </div>
      <div className="percentageDiscount">
        <span>{percentageDiscount ? `${formatPercent(percentageDiscount / 100, 0)} off` : ""}</span>
      </div>
      <div className="dates">
        <span id="startDate">{dateToMddyy(startDate.toISOString())}</span>
        <span id="dateSeparator"> - </span>
        <span id="endDate">{dateToMddyy(endDate.toISOString())} </span>
      </div>
    </div>
  );
};

export default TimelineAxisRow;
